<template>
    <div>
      <H4>Reports VIEW FOR SENIOR! NEEDS WORK!!!</H4>  
        <b-card>
            <b-tabs>
              <b-tab title="Report1">1</b-tab>
              <b-tab title="Report2">2</b-tab>
              <b-tab title="Report3">3</b-tab>
              <b-tab title="Report4">4</b-tab>
              </b-tabs>
        
        </b-card>
    
    </div>
  </template>
  
  <script>
  
  export default {
    components: {

    },
  
    data() {
      return {
       
        CompanyName: this.$Company,
        UserURN: this.$UserURN,
        UserName: this.$FullName,

      };
    },
  
    async mounted() {},
  
    methods: {},
  
    watch: {
      location() {
        this.filterLocations();
      },
    },
  };
  </script>
  
  <style scoped>
 

  </style>
  